import React from "react";
import Header from "../components/layouts/Headers";
import Footer from "../components/layouts/footer";
import MainRoutes from "../routes/Routers";
import { useLocation } from "react-router-dom";


function Layout() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');


  return (
    <div>
      {!isAdminRoute && <Header />}
      <main>
        <MainRoutes />
      </main>
      {!isAdminRoute && <Footer />}
    </div>
  );
}

export default Layout;
